import DotsWhiteLoading from 'components/loadings/dotsWhiteLoading'
import React from 'react'
import { useNavigate } from 'react-router-dom'
interface IFooterProps {
    isLoading: boolean
}
export default function Footer({ isLoading }: IFooterProps) {
    const navigate = useNavigate()
    return (
        <div className=" absolute bottom-0 w-full">
            <div className=" flex flex-col mx-4">
                <button
                    className=" text-center bg-green-1 text-white rounded-lg py-2.5"
                    disabled={isLoading}
                >
                    {!isLoading ? (
                        '                    ثبت درخواست'
                    ) : (
                        <DotsWhiteLoading />
                    )}
                </button>
                <button className=" my-3" onClick={() => navigate(-1)}>
                    بعدا
                </button>
            </div>
        </div>
    )
}
